import * as api from 'syft-acp-core/api/resources/admin/payments'
import { takeLatestApiCall } from './helpers'

export default function* root() {
  yield takeLatestApiCall('PAYMENTS_FETCH', api.fetchPayments)
}
